<style scope>
</style>

<template>
  <section class="container">
    <orcamento-piller-inativo/>
  </section>
</template>

<script>
  import OrcamentoPillerInativo from './piller/OrcamentoPillerInativo'

  export default {
    components: {OrcamentoPillerInativo},
    created () {
      if (!this.$store.state.parametros || !this.$store.state.parametros.id) {
        this.$air.sair()
        this.$root.$emit('acessar')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/orcamento/FormInativo.vue